import * as amplitude from '@amplitude/analytics-browser';
import { VpButton, VpIcon, VpLoader } from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoles } from '../../contexts/RolesContext';
import { useGenders } from '../../hooks/useGenders';
import { useSportsByIds } from '../../hooks/useSports';
import { capitalizeString } from '../../utils/text-display';
import { ArchitectureTable } from '../architectureTable';
import { ErrorPage } from '../errorPage';
import GoBackLink from '../goBackLink/GoBackLink';
import { HeaderDisplay } from '../headerDisplay';
import { Layout } from '../layout';
import { ArchiHeaderBalancer } from './archiHeaderSettings/ArchiHeaderBalancer';
import { ArchitectureModal } from './ArchitectureModal';

import './architecture.scss';

export const Architecture = () => {
  const [isArchitectureModalOpen, setIsArchitectureModalOpen] = useState(false);

  const { t } = useTranslation();

  const { hasRoleVisualization } = useRoles();

  const params = new URLSearchParams(document.location.search);
  const sportId = parseInt(params.get('sportId') || '0', 10);

  const { data: genderData } = useGenders([]);
  const { data: sportData, isFetching: isSportDataLoading } = useSportsByIds(
    sportId ? [sportId] : [],
  );

  return (
    <Layout>
      {hasRoleVisualization ? (
        <div className="architecture-page-container">
          <HeaderDisplay />
          <div data-testid="architecture-page">
            <GoBackLink path="/personal-offer" />
            <div
              className="architecture-header"
              data-testid="architecture-header"
            >
              <span
                className="architecture-subtitle"
                data-testid="architecture-subtitle"
              >
                {sportData ? (
                  <h1>{capitalizeString(sportData[0].name)}</h1>
                ) : (
                  <VpLoader size="medium" />
                )}
              </span>
              <VpButton
                size="small"
                shape="squared"
                variant="secondary"
                data-testid="sport_cta"
                aria-label="search sport"
                onClick={() => {
                  setIsArchitectureModalOpen(true);
                  amplitude.track('Architecture_Search-Sport');
                }}
              >
                <VpIcon name="search" size={16} />
                {t('architecture.search-sport')}
              </VpButton>
            </div>
          </div>
          <ArchitectureModal
            isOpen={isArchitectureModalOpen}
            setIsOpenModal={setIsArchitectureModalOpen}
          />
          {sportData && genderData && (
            <ArchiHeaderBalancer
              isSportDataLoading={isSportDataLoading}
              sportData={sportData}
              genderData={genderData}
              sportId={sportId}
            />
          )}
          {Boolean(sportId) && sportData && (
            <ArchitectureTable sportId={sportId} sportData={sportData} />
          )}
        </div>
      ) : (
        <ErrorPage
          errorPageTitle={t('no-access-page.title')}
          errorMessage={t('no-access-page.subtitle')}
        />
      )}
    </Layout>
  );
};
